import React from 'react';
import { ALL_ROLES_LABEL, DEFAULT_DISTRIBUTION, DISTRIBUTIONS, DISTRIBUTION_IDS, DISTRIBUTION_ROLES, DISTRIBUTION_ROLE_LABELS } from '../../config/products';
import type { DistributionId, DistributionRole } from '../../config/products';

/** What an Activities job counts: Totals (one measure per area) or Distributions (arrivals by band). */
export interface ActivityMode {
  kind: 'totals' | 'distributions';
  distribution: DistributionId;
  /** null for all roles. */
  role: DistributionRole | null;
}

export const TOTALS: ActivityMode = { kind: 'totals', distribution: DEFAULT_DISTRIBUTION, role: null };

interface ActivityModeControlProps {
  mode: ActivityMode;
  onChange: (mode: ActivityMode) => void;
}

/** The Totals / Distributions switch and, in Distributions, the Distribution and Role pickers. */
const ActivityModeControl: React.FC<ActivityModeControlProps> = ({ mode, onChange }) => (
  <div className="mb-4">
    <div role="group" aria-label="What to count" className="join mb-3 w-full">
      {(['totals', 'distributions'] as const).map((kind) => (
        <button
          key={kind}
          type="button"
          aria-pressed={mode.kind === kind}
          className={`btn btn-sm join-item flex-1 ${mode.kind === kind ? 'btn-primary' : 'btn-outline'}`}
          onClick={() => onChange({ ...mode, kind })}
        >
          {kind === 'totals' ? 'Totals' : 'Distributions'}
        </button>
      ))}
    </div>
    {mode.kind === 'distributions' ? (
      <>
        <label htmlFor="distribution-select" className="mb-1 block text-sm text-ink-muted">
          Distribution
        </label>
        <select
          id="distribution-select"
          className="select select-bordered select-sm w-full mb-3"
          value={mode.distribution}
          onChange={(e) => onChange({ ...mode, distribution: e.target.value as DistributionId })}
        >
          {DISTRIBUTION_IDS.map((id) => (
            <option key={id} value={id}>
              {DISTRIBUTIONS[id].label}
            </option>
          ))}
        </select>
        <label htmlFor="distribution-role-select" className="mb-1 block text-sm text-ink-muted">
          Role
        </label>
        <select
          id="distribution-role-select"
          className="select select-bordered select-sm w-full"
          value={mode.role ?? ''}
          onChange={(e) => onChange({ ...mode, role: (e.target.value || null) as DistributionRole | null })}
        >
          <option value="">{ALL_ROLES_LABEL}</option>
          {DISTRIBUTION_ROLES.map((r) => (
            <option key={r} value={r}>
              {DISTRIBUTION_ROLE_LABELS[r]}
            </option>
          ))}
        </select>
      </>
    ) : null}
  </div>
);

export default ActivityModeControl;
